export default {
  meta: {
    title: '拓店管理-落位报表',
    url: '/fishtogether/landedpositionreport', // 埋点用，记录所属模块
  },
};
